import React from "react"
import styled from "@emotion/styled"
import { Box } from "theme-ui"
import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const WhatsNewBox = styled(Box)`
    height: 535px;
    background: #ffffff;
    margin: 1rem;
    border-radius: 1rem;
    text-align: center;
    position: relative;
    flex: 0 0 350px;
    justify-content: space-between;
    border: 1px solid ${(props) => props.theme.colors.dark_grey};
    &:hover {
        box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    }

    & .image-round {
        display: inline-block;
        position: relative;
        overflow: hidden;
        border-radius: 1rem 1rem 0 0;
        border: 1px solid ${(props) => props.theme.colors.dark_grey};

        & img {
            width: auto;
            height: 100%;
            border-radius: 1rem 1rem 0 0;
        }
    }

    & p {
        margin: 2rem;
        text-align: center;
        margin: 1rem auto;
        color: ${(props) => props.theme.colors.text1};
        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[4]}) {
            font-size: 14px;
        }
    }
    & h4 {
        color: ${(props) => props.theme.colors.primary};
        font-weight: 400;
        margin: 3rem 0 0.5rem;
    }
    & .card-content {
        width: 100%;
        padding: 0 0.5rem;
    }
    & a {
        background: ${(props) => props.theme.colors.secondary};
        margin-top: 0.5rem;
        padding: 0.5rem 1.75rem;
        color: #ffffff;
        text-decoration: none;
        position: absolute;
        bottom: 10%;
        left: 32%;

        &:hover {
            text-decoration: none;
        }
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        height: auto;
        padding-bottom: 6rem;
        margin: 1rem auto;
        max-width: 350px;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[1]}) {
        & a {
            left: 25%;
        }
    }
`

const Cards = ({ summary, title, url, slug, imageFile }) => {
    let path = slug
    // if (path.split("-")[0] === process.env.PREFIX_SLUG) {
    //     path = path.replace(`${process.env.PREFIX_SLUG}-`, "")
    // }

    return (
        <WhatsNewBox
        // onMouseEnter={() => mouseHoverHandler(idx)}
        // onMouseLeave={mouseLeaveHandler}
        >
            <div className="image-round">
                {/* <img src="https://picsum.photos/370/220" alt="" /> */}
                <GatsbyImage image={getImage(imageFile)} alt={title} />
            </div>
            <h4>{title}</h4>
            <div
                className="card-content"
                dangerouslySetInnerHTML={{
                    __html: summary,
                }}
            ></div>
            <Link to={`${url}/${path}`}>Read More</Link>
        </WhatsNewBox>
    )
}

export default Cards
